export default "assets/images/logo_small-92015a8d.png";